/* eslint-disable max-len */
import { INTL_IDS } from './messages';

export const CHANGE_EMAIL = 'app/Settings/Profile/CHANGE_EMAIL';
export const CHANGE_EMAIL_FAILURE = 'app/Settings/Profile/CHANGE_EMAIL_FAILURE';
export const CHANGE_EMAIL_SUCCESS = 'app/Settings/Profile/CHANGE_EMAIL_SUCCESS';
export const CHANGE_EMAIL_VALIDATION_FAILURE = 'app/Settings/Profile/CHANGE_EMAIL_VALIDATION_FAILURE';

export const CHANGE_INPUT = 'app/Settings/Profile/CHANGE_INPUT';
export const CHANGE_INPUT_ERROR = 'app/Settings/Profile/CHANGE_INPUT_ERROR';

export const CHANGE_MOBILE_NUMBER = 'app/Settings/Profile/CHANGE_MOBILE_NUMBER';
export const CHANGE_MOBILE_NUMBER_FAILURE = 'app/Settings/Profile/CHANGE_MOBILE_NUMBER_FAILURE';
export const CHANGE_MOBILE_NUMBER_SUCCESS = 'app/Settings/Profile/CHANGE_MOBILE_NUMBER_SUCCESS';
export const CHANGE_MOBILE_NUMBER_VALIDATION_FAILURE = 'app/Settings/Profile/CHANGE_MOBILE_NUMBER_VALIDATION_FAILURE';

export const CHANGE_PASSWORD = 'app/Settings/Profile/CHANGE_PASSWORD';
export const CHANGE_PASSWORD_FAILURE = 'app/Settings/Profile/CHANGE_PASSWORD_FAILURE';
export const CHANGE_PASSWORD_SUCCESS = 'app/Settings/Profile/CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_VALIDATION_FAILURE = 'app/Settings/Profile/CHANGE_PASSWORD_VALIDATION_FAILURE';

export const CHANGE_STEP = 'app/Settings/Profile/CHANGE_STEP';

export const CHOOSE_DOCUMENT = 'app/Settings/Profile/CHOOSE_DOCUMENT';
export const CHOOSE_DOCUMENT_CANCELLATION = 'app/Settings/Profile/CHOOSE_DOCUMENT_CANCELLATION';
export const CHOOSE_DOCUMENT_FAILURE = 'app/Settings/Profile/CHOOSE_DOCUMENT_FAILURE';
export const CHOOSE_DOCUMENT_SUCCESS = 'app/Settings/Profile/CHOOSE_DOCUMENT_SUCCESS';

export const CLOSE_MODAL_STATE = 'app/Settings/Loans/CLOSE_MODAL_STATE';

export const FETCH_LEGAL_NAME_MILITARY_STATUS = 'app/Settings/Profile/FETCH_LEGAL_NAME_MILITARY_STATUS';
export const FETCH_LEGAL_NAME_MILITARY_STATUS_FAILURE = 'app/Settings/Profile/FETCH_LEGAL_NAME_MILITARY_STATUS_FAILURE';
export const FETCH_LEGAL_NAME_MILITARY_STATUS_SUCCESS = 'app/Settings/Profile/FETCH_LEGAL_NAME_MILITARY_STATUS_SUCCESS';

export const FETCH_MOBILE_NUMBER_STATUS = 'app/Settings/Profile/FETCH_MOBILE_NUMBER_STATUS';
export const FETCH_MOBILE_NUMBER_STATUS_FAILURE = 'app/Settings/Profile/FETCH_MOBILE_NUMBER_STATUS_FAILURE';
export const FETCH_MOBILE_NUMBER_STATUS_SUCCESS = 'app/Settings/Profile/FETCH_MOBILE_NUMBER_STATUS_SUCCESS';

export const FETCH_PROFILE = 'app/Settings/Profile/FETCH_PROFILE';
export const FETCH_PROFILE_FAILURE = 'app/Settings/Profile/FETCH_PROFILE_FAILURE';
export const FETCH_PROFILE_SUCCESS = 'app/Settings/Profile/FETCH_PROFILE_SUCCESS';

export const INPUT_ERRORS = 'app/Settings/Profile/INPUT_ERRORS';

export const OPEN_MODAL_STATE = 'app/Settings/Loans/OPEN_MODAL_STATE';

export const PROCESS_DOCUMENT = 'app/Settings/Profile/PROCESS_DOCUMENT';
export const PROCESS_DOCUMENT_FAILURE = 'app/Settings/Profile/PROCESS_DOCUMENT_FAILURE';
export const PROCESS_DOCUMENT_SUCCESS = 'app/Settings/Profile/PROCESS_DOCUMENT_SUCCESS';

export const RESET_BANNER_ERROR = 'app/Settings/Profile/RESET_BANNER_ERROR';
export const RESET_ERRORS_STATE = 'app/Settings/Profile/RESET_ERRORS_STATE';
export const RESET_FORM_ERRORS_STATE = 'app/Settings/Profile/RESET_FORM_ERRORS_STATE';
export const RESET_FORM_STATE = 'app/Settings/Profile/RESET_FORM_STATE';
export const RESET_REQUEST_STATUS_STATE = 'app/Settings/Profile/RESET_REQUEST_STATUS_STATE';
export const RESET_STEP_STATE = 'app/Settings/Profile/RESET_STEP_STATE';

export const UPLOAD_DOCUMENT = 'app/Settings/Profile/UPLOAD_DOCUMENT';
export const UPLOAD_DOCUMENT_FAILURE = 'app/Settings/Profile/UPLOAD_DOCUMENT_FAILURE';
export const UPLOAD_DOCUMENT_SUCCESS = 'app/Settings/Profile/UPLOAD_DOCUMENT_SUCCESS';

export const VERIFY_MOBILE_NUMBER = 'app/Settings/Profile/VERIFY_MOBILE_NUMBER';
export const VERIFY_MOBILE_NUMBER_FAILURE = 'app/Settings/Profile/VERIFY_MOBILE_NUMBER_FAILURE';
export const VERIFY_MOBILE_NUMBER_SUCCESS = 'app/Settings/Profile/VERIFY_MOBILE_NUMBER_SUCCESS';
export const VERIFY_MOBILE_NUMBER_VALIDATION_FAILURE = 'app/Settings/Profile/VERIFY_MOBILE_NUMBER_VALIDATION_FAILURE';

// Success and error messages

export const CHANGE_EMAIL_ERROR_MESSAGE = 'We are unable to save your account information at this time. Please try again later.';

export const CHANGE_EMAIL_SUCCESS_MESSAGE = 'The email has been changed';

export const CHANGE_MOBILE_NUMBER_ERROR_MESSAGE = 'We are unable to save your account information at this time. Please try again later.';

export const FETCH_MOBILE_NUMBER_STATUS_ERROR_MESSAGE = 'We are unable to retrieve your SMS settings at this time, please try again later';

export const FETCH_PROFILE_ERROR_MESSAGE = 'We are unable to retrieve your account information at this time, please try again later';

export const RESEND_PASSCODE_SUCCESS_MESSSAGE = 'Code successfully resent.';

export const VERIFY_MOBILE_NUMBER_ERROR_MESSAGE = 'We are unable to verify your pass code at this time. Please try again later.';

export const VERIFY_MOBILE_NUMBER_SUCCESS_MESSAGE = 'Pass code has been successfully verified';

export const UPLOAD_DOCUMENT_CONFIRMATION_DICTIONARY = {
  error: {
    text: 'For assistance, contact {{customerServicePhone}}.',
    title: 'We are unable to upload your document at this time',
  },
  success: {
    text: 'Your request has been received and is being processed. You will get an email notification once your request is reviewed. This usually takes a few business days.',
    title: 'Success!{{desktopNewline}}We received your request',
  },
};

export const ERROR_MESSAGES = {
  3003.2001: 'Unable to find user',
  3003.2002: 'New Email is required',
  3003.2003: 'New Email is not valid',
  3003.2004: 'New Email is confirmed to be the same as current email',
  3003.2005: 'New Email is already in use',
  3003.2006: 'Provided email length is greater than allowed amount',
};

export const PASSWORD_CONTENT_DICTIONARY = {
  header: 'Edit Password',
  subheader: 'Update your password regularly',
  text: '<b>Password requirements:</b> 10 Character minimum, 1 uppercase, 1 lowercase, 1 number. Special characters may be used.',
};

export const PASSWORD_ERROR_MESSAGES = {
  '3002.2000': { field: 'oldPassword', message: 'Current Password is required' },
  3002.2001: { field: 'newPassword', message: 'New Password is required' },
  3002.2002: { field: 'oldPassword', message: 'Current Password does not match existing password' },
  3002.2003: { field: 'newPassword', message: 'New Password has already been used' },
  3002.2004: { field: 'newPassword', messsage: 'New password must be at least 10 characters long and must contain at least 1 lower case, 1 upper case, and 1 number' },
};

export const SMS_ERROR_MESSAGES = {
  11001: 'SMS service not available for the loan',
  11002: 'SMS change request is invalid',
  '11002.1000': 'SMS service not available for the loan',
  11002.1001: 'Mobile number is required',
  11002.1002: 'Mobile number is not valid',
  11002.1003: 'Mobile number has not changed',
  11002.1004: 'Mobile number area code is not valid',
  11002.1005: 'Verification pass code is required',
  11002.1006: 'Verification pass code is not valid',
  11002.1007: 'SMS change request is empty',
  11002.1008: 'Too many requests to change mobile number',
  11002.1009: 'SMS Change request not allowed',
  '11002.1010': 'An SMS verification notification cannot be sent at this time. Please try again later.',
  11003: 'SMS service not available at this time',
};

export const PROFILE_CONTENT_DICTIONARY = {
  editEmail: {
    confirmationView: {
      desktop: {
        heading: 'Success!',
        subheading: 'Your email address has been updated',
      },
      mobile: {
        header: 'Confirmation',
        subheader: 'Success! Your email address has been updated',
      },
    },
    editEmailView: { header: 'Edit Email Address' },
  },
  editLegalName: {
    confirmationView: {
      header: 'Confirmation',
      mobile: {
        errorText: 'We are unable to upload your documents at this time',
        header: 'Confirmation',
        subheader: 'Success! We received your request',
        text1: 'Your request has been received and is being processed. You will get an email notification once your request is reviewed. This usually takes a few business days.',
        text2: 'We will make every effort to provide a response to your inquiry as promptly as possible. In any event, we will do so within the time limit required by law.',
      },
      subheader: 'Success! We received your request',
      text1: 'Your request has been received and is being processed. You will get an email notification once your request is reviewed. This usually takes a few business days.',
      text2: 'We will make every effort to provide a response to your inquiry as promptly as possible. In any event, we will do so within the time limit required by law.',
    },
    editLegalNameView: {
      header: 'Edit Legal Name',
      subheader: 'Get ready to upload proof of identity',
      text: 'Updating your legal name is simple, we just need to verify your identity first. For the next step, please have one form of identification ready to upload. Make sure it shows your updated legal name.',
    },
    reviewUploadView: { text: 'Your request will be processed once we receive your proof of legal name change.' },
    uploadView: {
      header: 'Upload Legal Document',
      mobileHeader: 'Upload Documents',
      subheader: 'Upload one of these documents',
      text: {
        divorce: {
          header: 'Divorce Decree',
          subheader: INTL_IDS.PROFILECONTENT_EDITLEGALNAME_UPLOADVIEW_TEXT_DIVORCE_SUBHEADER,
        },
        id: {
          header: 'Valid Government Issued ID',
          subheader: 'This includes a Driver’s License, State ID, or Passport that reflect the name change.',
        },
        marriage: {
          header: 'Marriage Certificate',
          subheader: 'Marriage must have already taken place.',
        },
      },
    },
  },
  editMilitaryStatus: {
    confirmationView: {
      header: 'Confirmation',
      mobile: {
        errorText: 'We are unable to upload your documents at this time',
        header: 'Confirmation',
        subheader: 'Success! We received your request',
        text1: 'Your request has been received and is being processed. You will get an email notification once your request is reviewed. This usually takes a few business days.',
        text2: 'We will make every effort to provide a response to your inquiry as promptly as possible. In any event, we will do so within the time limit required by law.',
      },
      subheader: 'Success! We received your request',
      text1: 'Your request has been received and is being processed. You will get an email notification once your request is reviewed. This usually takes a few business days.',
      text2: 'We will make every effort to provide a response to your inquiry as promptly as possible. In any event, we will do so within the time limit required by law.',
    },
    editMilitaryStatusView: {
      header: 'Edit Military Status',
      subheader: 'Get ready to upload proof of military status',
      text: 'Updating your military status is simple, we just need to verify your documents first. For the next step, you will need to upload one document indicating military service. Make sure it shows your legal name and date of service.',
    },
    reviewUploadView: { text: 'Your request will be processed once we receive your proof of military status.' },
    uploadView: {
      header: 'Upload Military Status Document',
      mobileHeader: 'Upload Documents',
      subheader: 'Document Requirements',
      text: {
        first: {
          bullets: ['Copy of the military orders calling you to service',
            'Certified letter from a commanding officer',
            'Any other written notice of your military service'],
          header: 'What counts as written notice of Military Service?',
        },
        second: {
          bullets: ['Full-time, active-duty members of the five military branches (Army, Navy, Air Force, Marine Corps, and Coast Guard)',
            'Reservists on federal active duty',
            'Members of the National Guard on federal orders for a period of more than 30 days'],
          header: 'What counts as Military Service?',
        },
      },
    },
  },
  editMobileNumber: {
    confirmationView: {
      desktop: {
        header: 'Confirmation',
        subheader: 'Success!\nYour mobile number has been updated',
      },
      mobile: {
        header: 'Confirmation',
        subheader: 'Success! Your mobile number has been updated',
      },
    },
    editMobileNumberView: {
      header: 'Edit Mobile Number',
      text: 'You will need your mobile device for the next step. After submitting your new number, a six-digit verification PIN will be sent to that number. You will have 30 minutes to enter the PIN. Message and data rates may apply.',
    },
    verifyMobileNumberView: {
      header: 'Verify Your Identity',
      subheader: 'Your safety is our top priority',
      text: 'A temporary identification code has been sent to <b>{{newMobileNumber}}</b>',
    },
  },
};
